/** @format */

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ProductReviewsDataAccessModule } from '@product-reviews/data-access';
import { ReviewAISummaryComponent } from '../review-ai-summary/review-ai-summary.component';
import { ReviewAiProsConsComponent } from '../review-ai-pros-cons/review-ai-pros-cons.component';
import { ReviewButtonComponentModule } from '../review-button/review-button.module';
import { ReviewCarouselComponentModule } from '../review-carousel/review-carousel.module';
import { ReviewContentListModule } from '../review-content-list/review-content-list.module';
import { ReviewHighlightContainerComponent } from './review-highlight-container.component';
import { ReviewLatestCarouselComponentModule } from '../review-latest-carousel/review-latest-carousel.module';
import { ReviewResponsiveRatingSummaryComponent } from '../review-responsive-rating-summary/review-responsive-rating-summary.component';
import { ReviewSecondaryRatingModule } from '../review-secondary-rating/review-secondary-rating.module';
import { ReviewsSummaryModule } from '../reviews-summary/reviews-summary.module';

@NgModule({
	imports: [
		CommonModule,
		ProductReviewsDataAccessModule,
		ReviewAiProsConsComponent,
		ReviewAISummaryComponent,
		ReviewButtonComponentModule,
		ReviewCarouselComponentModule,
		ReviewContentListModule,
		ReviewLatestCarouselComponentModule,
		ReviewResponsiveRatingSummaryComponent,
		ReviewSecondaryRatingModule,
		ReviewsSummaryModule
	],
	declarations: [ReviewHighlightContainerComponent],
	exports: [ReviewHighlightContainerComponent]
})
export class ReviewHighlightContainerModule {}
